(function() {
    'use strict';

    angular.module('showcaseApp')
        .component('hubStoreDropdown', {
            templateUrl: 'app/components/store-multi-select/store-multi-select.html',
            controller: HubStoreDropdownController,
            controllerAs: 'vm',
            bindings: {
                stores: '<',
                storeTypes: '<',
                onStoreSelected: '&',
                onStoreTypeChange: '&',
                onToggleClick: '&'
            }
        });

    function HubStoreDropdownController($scope, $document, $element, systemConstants, $window,$translate, StoreService, $timeout, StoreTypeService) {
        var vm = this;

        var STORE_PAGE_DEFAULT = 0;
        var STORE_SIZE_DEFAULT = 100;

        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.isDropdownOpen = false;
        vm.showTypeOptions = false;
        vm.isToggleActive = false;

        vm.isLoadingMore = false;
        vm.hasMoreStores = true;

        vm.storeName = '';

        vm.isAllSelectedMode = false;
        vm.selectedStoreType = null;
        vm.excludedIds = [];
        vm.storesSelected = [];

        vm.uiState = {
            isToggleActive: false,
            selectedStoreType: null,
            showTypeOptions: false,
            storeName: '',
            selectedStoreTypeName: ''
        };

        vm.requestParamsStore = {
            page: STORE_PAGE_DEFAULT,
            size: STORE_SIZE_DEFAULT
        }

        var onClickOutside = function(event) {
            var isClickInside = $element[0].contains(event.target);
            var clickedOnAnotherSelect = event.target.closest('.alternative-dropdown');

            if (!isClickInside) {
                $scope.$apply(function() {
                    vm.isDropdownOpen = false;
                    vm.showTypeOptions = false;

                    vm.resetSearch();
                });
            }

            if (clickedOnAnotherSelect && !isClickInside) {
                $scope.$applyAsync(function () {
                    vm.isDropdownOpen = false;
                    vm.resetSearch();
                });
            }
        };

        function loadStores(pageOptions, append) {
            if (vm.isLoadingMore || (!vm.hasMoreStores && append)) {
                return;
            }

            vm.isLoadingMore = true;

            pageOptions = pageOptions || {};
            pageOptions.name = vm.uiState.storeName;

            StoreService.listStoresByCurrentHub({}, pageOptions,
                function (data) {
                    if (!data || data.length === 0) {
                        vm.hasMoreStores = false;
                        vm.isLoadingMore = false;
                        if (!append) {
                            vm.stores = [];
                        }
                        return;
                    }

                    if (append) {
                        vm.stores = vm.stores.concat(data);
                    } else {
                        vm.stores = data;
                        vm.hasMoreStores = true;
                    }

                    vm.filteredStores = vm.stores;
                    vm.isLoadingMore = false;
                },
                function () {
                    vm.isLoadingMore = false;
                }
            );
        }

        vm.loadNextPage = function () {
            if (!vm.hasMoreStores || vm.isLoadingMore) {
                return;
            }

            vm.requestParamsStore.page += 1;
            loadStores(vm.requestParamsStore, true);
        };


        vm.$onInit = function () {
            StoreTypeService.getAllStoreTypesByOwner().then(function (response) {
                vm.storeTypes = response.data;

                vm.storeTypes.unshift({
                    id: 'all_stores',
                    name: $translate.instant('global.hub.store-toggle')
                });

                vm.allTypeOptions = vm.storeTypes;
            });
            vm.requestParamsStore.name = vm.storeName;
            loadStores(vm.requestParamsStore);
            vm.uiState = {
                isToggleActive: false,
                selectedStoreType: null,
                storeName: '',
                selectedStoreTypeName: ''
            };

            vm.storesSelected = [];
            vm.filteredStores = angular.copy(vm.stores);

            document.addEventListener('click', onClickOutside, true);
        };

        $scope.$watch(
            function () {
                return vm.isDropdownOpen;
            },
            function (isOpen) {
                if (isOpen) {
                    bindScroll();
                } else {
                    unbindScroll();
                }
            }
        );

        vm.bindScroll = function () {
            if (vm.isMobile && !vm.mobileStateSnapshot) {
                vm.mobileStateSnapshot = {
                    selectedStoreType: angular.copy(vm.uiState.selectedStoreType),

                    selectedStoreTypeId: vm.selectedStoreTypeId,
                    selectedStoreTypeName: vm.selectedStoreTypeName,
                    isAllSelectedMode: vm.isAllSelectedMode,
                    excludedIds: angular.copy(vm.excludedIds),
                    storesSelected: angular.copy(vm.storesSelected)
                };
            }
            bindScroll();
        };


        function bindScroll() {
            $scope.$evalAsync(function () {
                var searchElement = function() {
                    vm.scrollContainer = $element[0].querySelector('.stores-scroll-area');

                    if (vm.scrollContainer) {
                        vm.scrollContainer.addEventListener('scroll', onScroll);
                    } else {
                        $timeout(searchElement, 200);
                    }
                };
                searchElement();
            });
        }

        function unbindScroll() {
            if (vm.scrollContainer) {
                vm.scrollContainer.removeEventListener('scroll', onScroll);
                vm.scrollContainer = null;
            }
        }

        vm.$postLink = function () {
            var scrollContainer = $element[0].querySelector('.stores-scroll-area');

            if (!scrollContainer) {
                return;
            }

            scrollContainer.addEventListener('scroll', onScroll);
        };

        function onScroll(event) {
            var el = event.target;

            var isNearBottom =
                el.scrollTop + el.clientHeight >= el.scrollHeight - 50;

            if (isNearBottom) {
                $scope.$applyAsync(vm.loadNextPage);
            }
        }

        vm.$onDestroy = function () {
            unbindScroll();
            document.removeEventListener('click', onClickOutside, true);
        };

        vm.checkStoreIsSelected = function(store) {
            if (!store) {
                return false;
            }

            if ((!store) || (vm.excludedIds && vm.excludedIds.indexOf(store.storeId) > -1)) {
                return false;
            }

            if ((vm.selectedStoreTypeName && store.storeType === vm.selectedStoreTypeName) || (vm.isAllSelectedMode) ) {
                return true;
            }


            return vm.storesSelected && vm.storesSelected.indexOf(store.storeId) > -1;
        };

        vm.resetSearch = function () {
            vm.uiState.storeName = '';
            vm.requestParamsStore.name = '';
            vm.requestParamsStore.page = STORE_PAGE_DEFAULT;
            vm.hasMoreStores = true;

            var el = $element[0].querySelector('.stores-scroll-area');
            if (el) {
                el.scrollTop = 0;
            }

            loadStores(vm.requestParamsStore, false);
        };


        vm.changeStoreSelected = function(store) {
            var isImplicitlySelected = vm.isAllSelectedMode || (store.storeType === vm.selectedStoreTypeName);

            if (isImplicitlySelected) {
                var index = vm.excludedIds.indexOf(store.storeId);
                index > -1 ? vm.excludedIds.splice(index, 1) : vm.excludedIds.push(store.storeId);
            } else {
                var index = vm.storesSelected.indexOf(store.storeId);
                index > -1 ? vm.storesSelected.splice(index, 1) : vm.storesSelected.push(store.storeId);
            }

            $scope.$applyAsync(function() { vm.notifyParent(); });
        };

        vm.notifyParent = function() {
            var dataToSend = {
                all: vm.isAllSelectedMode,
                selectedStoreTypeId: vm.selectedStoreTypeId ? vm.selectedStoreTypeId : null,
                excludedIds: angular.copy(vm.excludedIds),
                selectedIds: angular.copy(vm.storesSelected)
            };
            $timeout(function() {
                vm.onToggleClick({ stores: dataToSend });
            });
        };

        vm.selectStoreByType = function (typeObj) {
            vm.excludedIds = [];
            vm.storesSelected = [];

            if (!typeObj || typeObj.id === 'all_stores' || typeObj.id === '') {
                vm.isAllSelectedMode = (typeObj && typeObj.id === 'all_stores');
                vm.selectedStoreTypeId = null;
                vm.selectedStoreTypeName = null;
                vm.uiState.selectedStoreType = null;
            }
            else {
                vm.isAllSelectedMode = false;
                vm.selectedStoreTypeId = typeObj.id;
                vm.selectedStoreTypeName = typeObj.name;
                vm.uiState.selectedStoreType = typeObj;
            }

            vm.notifyParent();
        };

        vm.onApplyMobile = function() {
            vm.mobileStateSnapshot = null;
            vm.isDropdownOpen = false;
        };

        vm.closeDrawer = function () {
            unbindScroll();

            if (vm.isMobile && vm.mobileStateSnapshot) {
                vm.selectedStoreTypeId = vm.mobileStateSnapshot.selectedStoreTypeId;
                vm.selectedStoreTypeName = vm.mobileStateSnapshot.selectedStoreTypeName;
                vm.isAllSelectedMode = vm.mobileStateSnapshot.isAllSelectedMode;

                vm.excludedIds = angular.copy(vm.mobileStateSnapshot.excludedIds);
                vm.storesSelected = angular.copy(vm.mobileStateSnapshot.storesSelected);

                vm.uiState.selectedStoreType = vm.mobileStateSnapshot.selectedStoreType;

                vm.notifyParent();
                vm.mobileStateSnapshot = null;
            }

            var el = $element[0].querySelector('.stores-scroll-area');
            if (el) { el.scrollTop = 0; }

            vm.resetSearch();
        };

        vm.markAll = function() {
            vm.isAllSelectedMode = vm.uiState.isToggleActive;


            vm.storesSelected = [];
            vm.excludedIds = [];

            vm.onToggleClick({
                payload: {
                    all: vm.isAllSelectedMode,
                    excludedIds: vm.excludedIds,
                    selectedIds: vm.storesSelected
                }
            });
        };

        vm.onChangeStoreName = function () {
            vm.requestParamsStore.page = 0;
            vm.hasMoreStores = true;

            loadStores(vm.requestParamsStore, false);
        };

        $scope.$watch(function() {
            return vm.stores;
        }, function(newStores) {
            vm.filteredStores = angular.copy(newStores);
        }, true);
    }
})();
